import {Component} from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {ICellRendererParams} from "ag-grid-community";
import {MatButton} from "@angular/material/button";
import {ICharityBalance} from "../../../interfaces/charity/ICharityBalance";

@Component({
  selector: 'app-charity-payout-actions',
  standalone: true,
  templateUrl: './charity-payout-actions.component.html',
  imports: [
    MatButton
  ],
  styleUrls: ['./charity-payout-actions.component.css']
})
export class CharityPayoutActionsComponent implements ICellRendererAngularComp {

  public rowData!: ICharityBalance;
  // The row's name goes with its id: the payout screen shows the charity immediately rather than waiting
  // on the picker's option list (#1505).
  private onMakePayoutClick?: (charityId: string, charityName: string) => void;

  agInit(params: ICellRendererParams & {
    onMakePayoutClick?: (charityId: string, charityName: string) => void
  }): void {
    this.rowData = params.data;
    this.onMakePayoutClick = params.onMakePayoutClick;
  }

  refresh(_params: ICellRendererParams): boolean {
    return false;
  }

  handleMakePayoutClick(): void {
    if (this.onMakePayoutClick && this.rowData.CharityId) {
      this.onMakePayoutClick(this.rowData.CharityId, this.rowData.CharityName);
    }
  }

  shouldShowButton(): boolean {
    return this.rowData && this.rowData.AmountOwed > 0;
  }
}
